import React, { createContext, useEffect, useState, useContext } from "react";
import { Redirect } from "../../../utils/Redirect";
import { RetailContext } from "../../../contexts/retail/retailMain.context";
import { useRouter } from "../../../utils/hooks/useRouter";
import {
  getBranchFromMerchant,
  getMerchantInfo,
  getMerchantPriceBookRetail,
} from "../../api/retail/merchantInfoApi";
import { ShopInformation } from "../../../store/slices/shopSlice";
import { useAppSelector } from "../../../store/hooks";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { PRODUCT_TYPE_OTHER } from "../../../components/AdminMerchant/Retail/FeaturedCategories/constant";
import { OnboardingFeature } from "../../../store/slices/onboardingFeatureSlice";
import useMerchantPackage from "../../../hooks/useMerchantPackage";
import moment from "moment/moment";
import { BranchState } from "../../../components/AdminMerchant/Retail/SyncSettings/const";

export type TTypeRemainOrder = "productNotOrdered" | "infinity";
export const EnumOptionsRemainOrder: {
  productNotOrdered: TTypeRemainOrder;
  infinity: TTypeRemainOrder;
  showProductAvailable: boolean;
} = {
  productNotOrdered: "productNotOrdered",
  infinity: "infinity",
  showProductAvailable: false,
};
export const EnumWarningRemainOrder: {
  productNotOrdered: string;
  infinity: string;
  showProductAvailable: string;
} = {
  productNotOrdered: "SYSTEM_AUTOMATIC_CALCULATE_BASE_ON_REMAINING_STORAGE",
  infinity: "SYSTEM_AUTOMATIC_SHOW_ON_GOODS_IS_OOS",
  showProductAvailable: "GOODS_WILL_BE_NOT_DISPLAY_COUNT_AVAILABLE",
};

export type BranchesInfo = {
  is_onboarding_blog: boolean;
  _id: string;
  merchant_id: string;
  is_active: boolean;
  is_syncing: boolean;
  is_installed: boolean;
  is_published: boolean;
  is_onboarding: boolean;
  is_first_synced: boolean;
  theme_id: string;
  theme_name: string;
  theme_code: string;
  theme_color: string;
  theme_colors: string[];
  theme_setting_color: any[];
  theme_version: number;
  storefront_data: any[];
  is_stocked: boolean;
  price_formula_id: string;
  price_formula_name: string;
  promotion_formula_id: string;
  promotion_formula_name: string;
  merchant_name: string;
  merchant_email: string;
  merchant_phone: string;
  merchant_address: string;
  platform: string;
  ref_id: string;
  is_visible_warning_price_formula: boolean;
  name: string;
  address: string;
  phone: string;
  zalo_url: string;
  facebook_url: string;
  logo_url: string;
  logo_url_extra: string;
  banner_url: string;
  email_sent: boolean;
  allow_order_when_out_stock: boolean;
  is_show_guide_setting_order: boolean;
  product_type_displayed: number[];
  flow_version_weborder: number;
  theme_selected_color: string;
  theme_select_colors: string[];
  industry_id: number;
  onboarding_at: number;
  updated_at: number;
  created_at: number;
  qr_url: string;
  allow_in_store_transaction: boolean;
  color: string;
  email: string;
  id: string;
  web_order_slug: string;
  is_show_popup_onboard_done: boolean;
  state?: string;
};

export interface IRetailSettingContext {
  formula_default?: any;
  productStore: boolean;
  priceSale: string | undefined;
  pricePromotion: string | undefined;
  amountSale: string | undefined;
  listPriceBookAvailable?: any[];
  initSetting: {
    product_store: boolean;
    price_sale: string;
    price_promotion: string;
    amount_sale: string;
    product_type_displayed?: number[];
    type_remain_order: string;
    branchSyncId?: string;
    last_changed_branch_ref_id?: any;
    custom_price_text?: string;
  };
  synced: boolean; //when value of setting input not equal initSetting, then {synced set to false, button save setting is enable}
  rollback: number; //when send setting request to server response failed, rollback update value by Date.now(); all data in setting input rollback initSetting values.
  updateProductStore?: (productStore: boolean) => void;
  updatePriceSale?: (priceSale: string) => void;
  updatePricePromotion?: (pricePromotion: string) => void;
  updateAmountSale?: (amountSale: string) => void;
  setInitSetting?: ({
    product_store,
    price_sale,
    price_promotion,
    product_type_displayed,
    branchSyncId,
    last_changed_branch_ref_id,
  }: // amount_sale,
  any) => void;
  setSynced?: (synced: boolean) => void;
  setRollback?: (rollback: number) => void;
  typeRemainOrder: TTypeRemainOrder;
  setTypeRemainOrder?: (value: TTypeRemainOrder) => void;
  productTypeSetting?: number[];
  updateProductType?: (value: number, checked: boolean) => void;
  resetProductTypeToDefault?: () => void;
  showProductAvailable?: boolean;
  setShowProductAvailable?: (checked: boolean) => void;
  listBranches: BranchesInfo[];
  branchSynceId?: string;
  updateBranchSyncId?: (payload: { id: string; ref_id: string }) => void;
  getDataMerchant?: () => void;
  branch_sync: BranchesInfo;
  setBranch?: (branch: string) => void;
  updateProductTypeSetting?: (productTypeSetting: number[]) => void;
  listPriceBook: any[];
  priceBookError: string;
}

export const PRICE_BOOK_ERROR_CODE: { [key: number]: string } = {
  0: "ERROR_CODE_OK",
  1: "ERROR_CODE_NOT_VALID", //Bảng giá bán không trong phạm vị áp dụng của “Chi nhánh đồng bộ”
  2: "ERROR_CODE_NOT_VALID_TIME", //Bảng giá bán không còn thời gian hiệu lực
  3: "ERROR_CODE_NOT_APPLY", //Bảng giá bán có trạng thái “Chưa áp dụng”
  4: "ERROR_CODE_DELETE", //Bảng giá bán đã chọn nhưng vừa bị xóa
};

const PRICE_BOOK_ERROR_MESSAGE: { [key: string]: string } = {
  ERROR_CODE_NOT_VALID: "PRICE_IS_NOT_IN_SCOPE_OF_BRANCH",
  ERROR_CODE_NOT_APPLY: "PRICE_BOOK_IS_NOT_APPLIED",
  ERROR_CODE_NOT_VALID_TIME: "PRICE_BOOK_IS_EXPIRED",
  ERROR_CODE_DELETE: "PRICE_BOOK_IS_DELETED",
};

export const LIST_PATHNAME_IGNORE_INFO_BRANCH_SYNC = [
  "/admin-merchant/display-product",
];

export const RetailSettingContext = createContext<IRetailSettingContext>({
  productStore: false,
  priceSale: "",
  pricePromotion: "",
  amountSale: "",
  synced: true,
  initSetting: {
    product_store: false,
    price_sale: "",
    price_promotion: "",
    amount_sale: "tonkho_dathang",
    product_type_displayed: [2],
    type_remain_order: "",
    last_changed_branch_ref_id: null,
    custom_price_text: "Giá liên hệ",
  },
  rollback: 0,
  typeRemainOrder: EnumOptionsRemainOrder.productNotOrdered,
  showProductAvailable: false,
  setShowProductAvailable: () => {},
  listBranches: [],
  branchSynceId: "",
  updateBranchSyncId: () => {},
  getDataMerchant: () => {},
  branch_sync: {} as BranchesInfo,
  setBranch: () => {},
  listPriceBook: [],
  priceBookError: "",
});

export const constantNone = "none";
export const RetailSettingContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { setActiveNoty, setPriceBook } = useContext(RetailContext);

  const [initSetting, setInitSetting] = useState({
    product_store: false,
    price_sale: "",
    price_promotion: constantNone,
    amount_sale: "tonkho_dathang",
    type_remain_order: "productNotOrdered",
    product_type_displayed: [2],
    branchSyncId: "",
    last_changed_branch_ref_id: "",
    custom_price_text: "Giá liên hệ",
  });
  const [productTypeSetting, setProductTypeSetting] = useState<number[]>(
    initSetting.product_type_displayed
  );
  const [productStore, setProductStore] = useState(initSetting.product_store);
  const [priceSale, setPriceSale] = useState(initSetting.price_sale);
  const [pricePromotion, setPricePromotion] = useState(
    initSetting.price_promotion
  );
  const [amountSale, setAmountSale] = useState(
    initSetting.amount_sale || "tonkho_dathang"
  );
  const [typeRemainOrder, setTypeRemainOrder] =
    useState<TTypeRemainOrder>("productNotOrdered");

  const [synced, setSynced] = useState(false);
  const [rollback, setRollback] = useState(0);
  const [listPriceBookAvailable, setListPriceBookAvailable] = useState<
    any | undefined
  >(undefined);
  const router = useRouter();
  const [showProductAvailable, setShowProductAvailable] =
    useState<boolean>(false);
  const [listBranch, setListBranch] = useState<BranchesInfo[]>([]);
  const [branch, setBranch] = useState("");
  const [branchSync, setBranchSync] = useState<BranchesInfo>(
    {} as BranchesInfo
  );
  const [listPriceBook, setListPriceBook] = useState<any[]>([]);

  const [priceBookError, setPriceBookError] = useState<string>("");

  const { getShopPackage } = useMerchantPackage();

  function getTypeRemainOrder(branch: IRetailBranchInfo): TTypeRemainOrder {
    return branch?.allow_order_when_out_stock
      ? "infinity"
      : "productNotOrdered";
  }

  useEffect(() => {
    if (
      initSetting.product_store !== productStore ||
      initSetting.price_sale !== priceSale ||
      initSetting.price_promotion !== pricePromotion ||
      initSetting.amount_sale !== amountSale ||
      initSetting.type_remain_order !== typeRemainOrder ||
      initSetting.product_type_displayed !== productTypeSetting ||
      initSetting.branchSyncId?.toString() !== branch
    ) {
      setSynced(false);
    } else {
      setSynced(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    initSetting,
    productStore,
    priceSale,
    pricePromotion,
    amountSale,
    typeRemainOrder,
    productTypeSetting,
    branch,
    branchSync,
  ]);

  const handleNoty = (resMerchantInfo: any) => {
    if (resMerchantInfo?.branch?.is_visible_warning_price_formula) {
      setActiveNoty && setActiveNoty(true);
    }
  };
  const updateProductType = (value: number, checked: boolean) => {
    const isExists = productTypeSetting.includes(value);
    //
    if (checked && !isExists) {
      const newProductType = [...productTypeSetting, value];
      const compareArrayProductType = compareArray(
        initSetting.product_type_displayed,
        newProductType
      );
      if (!newProductType.includes(PRODUCT_TYPE_OTHER))
        newProductType.push(PRODUCT_TYPE_OTHER);
      setSynced(compareArrayProductType);
      setProductTypeSetting(newProductType);
      return;
    }
    if (!checked && isExists) {
      const newProductType = productTypeSetting.filter(
        (item) => item !== value
      );
      const compareArrayProductType = compareArray(
        initSetting.product_type_displayed,
        newProductType
      );
      if (!newProductType.includes(PRODUCT_TYPE_OTHER))
        newProductType.push(PRODUCT_TYPE_OTHER);
      setSynced(compareArrayProductType);
      setProductTypeSetting(newProductType);
      return;
    }
    setSynced(true);
    return;
  };

  const compareArray = (firstArr: any, secondArr: any) => {
    const sortedArray1 = firstArr.slice().sort();
    const sortedArray2 = secondArr.slice().sort();
    return JSON.stringify(sortedArray1) === JSON.stringify(sortedArray2);
  };

  const resetProductTypeToDefault = () => {
    setProductTypeSetting(initSetting.product_type_displayed);
  };
  const getDataMerchant = async () => {
    const platform = router.query.platform;
    if (!platform || typeof platform !== "string") {
      return () => {
        Redirect({ to: "/session-expired" });
      };
    }
    const promises = [getMerchantInfo({ platform }), getListBranch()];
    try {
      const [resMerchantInfo, branches] = await Promise.all(promises);
      if (resMerchantInfo.branch) {
        const newTypeRemainOrder = getTypeRemainOrder(resMerchantInfo.branch);
        const newPricePromotion = resMerchantInfo.branch_sync
          ? resMerchantInfo.branch_sync?.promotion_formula_id?.length !== 0
            ? resMerchantInfo.branch_sync?.promotion_formula_id
            : constantNone
          : resMerchantInfo.branch?.promotion_formula_id?.length !== 0
          ? resMerchantInfo.branch?.promotion_formula_id
          : constantNone;
        //@ts-ignore
        setInitSetting({
          product_store: resMerchantInfo.branch?.is_stocked,
          price_sale: resMerchantInfo.branch_sync?.price_formula_id,
          price_promotion: newPricePromotion,
          amount_sale: "tonkho_dathang",
          type_remain_order: newTypeRemainOrder,
          product_type_displayed:
            resMerchantInfo.branch?.product_type_displayed,
          branchSyncId:
            resMerchantInfo.merchant?.branch_sync_ref_id ||
            resMerchantInfo.merchant?.branch_official_id,
          last_changed_branch_ref_id:
            resMerchantInfo.merchant?.last_update_branch_sync_ref_id,
          custom_price_text: resMerchantInfo.merchant?.custom_price_text,
        });
        //@ts-ignore
        setProductStore(resMerchantInfo.branch?.is_stocked);
        //@ts-ignore
        if (resMerchantInfo.branch_sync?.state === BranchState.actived) {
          setPriceSale(resMerchantInfo.branch_sync?.price_formula_id);
        } else {
          setPriceSale(constantNone);
        }
        //@ts-ignore
        setPricePromotion(newPricePromotion);
        setTypeRemainOrder(newTypeRemainOrder);
        //@ts-ignore
        setProductTypeSetting(resMerchantInfo.branch?.product_type_displayed);
        setShowProductAvailable(resMerchantInfo.branch?.show_remain || false);

        //@ts-ignore
        setBranch(
          (
            resMerchantInfo.merchant?.branch_sync_ref_id ||
            resMerchantInfo.merchant?.branch_official_id
          ).toString()
        );
        handleNoty(resMerchantInfo);
      }

      if (resMerchantInfo.merchant) {
        await getShopPackage(resMerchantInfo.merchant);
      }

      if (branches.length) {
        setListBranch(branches);
      }

      if (resMerchantInfo.branch_sync) {
        setBranchSync({ ...resMerchantInfo.branch_sync });
        const matchPath = LIST_PATHNAME_IGNORE_INFO_BRANCH_SYNC.some(path => window.location.pathname.includes(path));

        if (!matchPath) {
          if (resMerchantInfo.branch_sync.id) {
            getDataMerchantPriceBook(resMerchantInfo.branch_sync.id);
          } else {
            getDataMerchantPriceBook();
          }
        }
      }
    } catch (e) {
      getDataMerchantPriceBook();
      Redirect({ to: "/internal-server-error" });
    }
  };

  useEffect(() => {
    getDataMerchant();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (branchSync.id) {
  //     getDataMerchantPriceBook(branchSync.id);
  //     return;
  //   }
  //   getDataMerchantPriceBook();
  // }, [branchSync]);

  async function updateProductStore(productStore: boolean) {
    setProductStore(productStore);
  }

  function updatePriceSale(priceSale: string) {
    setPriceSale(priceSale);
  }

  function updatePricePromotion(pricePromotion: string) {
    setPricePromotion(pricePromotion);
  }

  function updateAmountSale(amountSale: string) {
    setAmountSale(amountSale);
  }

  async function updateProductTypeSetting(productTypeSetting: number[]) {
    setProductTypeSetting(productTypeSetting);
  }

  const getDataMerchantPriceBook = async (branch_id?: string) => {
    const platform = router.query.platform;
    if (!platform || typeof platform !== "string") {
      return () => {
        Redirect({ to: "/session-expired" });
      };
    }

    const resPriceBook: any = await getMerchantPriceBookRetail({
      platform,
      branch_id,
      get_all: true,
    });
    if (!resPriceBook.errors) {
      setListPriceBookAvailable(resPriceBook.price_formula_select);
      setListPriceBook(resPriceBook.price_formulas);
      setPriceBook && setPriceBook(resPriceBook.price_formula_id);
      if (
        resPriceBook.error_code !== 0 &&
        PRICE_BOOK_ERROR_CODE[resPriceBook.error_code]
      ) {
        const resPriceBookError =
          PRICE_BOOK_ERROR_CODE[resPriceBook.error_code];
        setPriceBookError(PRICE_BOOK_ERROR_MESSAGE[resPriceBookError]);
      } else {
        setPriceBookError("");
      }
      return;
    }
    setListPriceBookAvailable([]);
    setPriceBook && setPriceBook([]);
  };

  const getListBranch = async () => {
    const platform = router.query.platform;
    const response = await getBranchFromMerchant(platform || "retail");
    if (response.success) {
      return response.data;
    }
    return [];
  };

  const updateBranchSyncId = async ({
    id,
    ref_id,
  }: {
    id: string;
    ref_id: string;
  }) => {
    await getDataMerchantPriceBook(id);
    setBranch(ref_id);
  };
  return (
    <RetailSettingContext.Provider
      value={{
        productStore,
        priceSale,
        pricePromotion,
        amountSale,
        synced,
        initSetting,
        rollback,
        updateProductStore,
        updatePriceSale,
        updatePricePromotion,
        updateAmountSale,
        setInitSetting,
        setSynced,
        setRollback,
        listPriceBookAvailable,
        typeRemainOrder,
        setTypeRemainOrder,
        updateProductType,
        productTypeSetting,
        resetProductTypeToDefault,
        setShowProductAvailable,
        showProductAvailable,
        listBranches: listBranch,
        updateBranchSyncId,
        branchSynceId: branch,
        getDataMerchant,
        branch_sync: branchSync,
        setBranch,
        updateProductTypeSetting,
        listPriceBook: listPriceBook,
        priceBookError: priceBookError,
      }}
    >
      {children}
    </RetailSettingContext.Provider>
  );
};
